import { toast } from 'react-toastify';

import moment from 'moment';
import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
} from './actions';

export function* requestOperacaoImpedimentos({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'impedimentos', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* deleteOperacaoImpedimentos({ payload }) {
  try {
    const { imab_codigo, params } = payload;

    yield call(api.delete, `impedimentos/${imab_codigo}`);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* store({ payload }) {
  try {
    const { operacaoimpedimentos, params } = payload;

    yield call(api.post, 'impedimentos', operacaoimpedimentos);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    history.push('/impedimento');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* find({ payload }) {
  try {
    const { imab_codigo } = payload;

    const { data } = yield call(api.get, `impedimentos/${imab_codigo}`);

    const dataMod = {
      ...data,
      datahorainicialmovimentacao: moment(
        data.datahorainicialmovimentacao,
        'DD/MM/YYYY HH:mm:ss',
        true
      ).format('YYYY-MM-DDTHH:mm:ss'),
      datahorafinalmovimentacao: moment(
        data.datahorafinalmovimentacao,
        'DD/MM/YYYY HH:mm:ss',
        true
      ).format('YYYY-MM-DDTHH:mm:ss'),
    };

    yield put(successRequest(dataMod));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* update({ payload }) {
  try {
    const { operacaoimpedimentos, params } = payload;

    yield call(api.put, 'impedimentos', operacaoimpedimentos);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/impedimento');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* applyedFilters({ payload }) {
  try {
    const { params } = payload;

    const response = yield call(api.get, 'impedimentos', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export default all([
  takeLatest(
    '@operacaoimpedimentos/IMPEDIMENTOS_IN_REQUEST',
    requestOperacaoImpedimentos
  ),
  takeLatest(
    '@operacaoimpedimentos/DELETE_IMPEDIMENTOS',
    deleteOperacaoImpedimentos
  ),
  takeLatest(
    '@operacaoimpedimentos/SUCCESS_REMOVE',
    requestOperacaoImpedimentos
  ),
  takeLatest('@operacaoimpedimentos/STORE_IMPEDIMENTOS', store),
  takeLatest('@operacaoimpedimentos/FIND_IMPEDIMENTOS', find),
  takeLatest('@operacaoimpedimentos/UPDATE_IMPEDIMENTOS', update),
  takeLatest('@operacaoimpedimentos/RECORD_FILTERING', applyedFilters),
]);
